// 必須先於 Turbo 註冊 popstate，避免返回點餐頁時先被 Turbo 重建畫面。
import './utils/orderBackNavigationGuard'

// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Import Turbo for smooth page transitions
import * as Turbo from '@hotwired/turbo'
Turbo.start()

// 防止 Turbo 攔截 Cloudflare email protection 連結
document.addEventListener('turbo:click', (event) => {
  if (event.detail.url && event.detail.url.includes('/cdn-cgi/')) {
    event.preventDefault()
  }
})

// Import main CSS stylesheet
import '../../assets/stylesheets/tailwind.css'
import '../../assets/stylesheets/main.css'

// Import Bootstrap JavaScript (for Modal and Offcanvas functionality)
import 'bootstrap/dist/js/bootstrap.bundle.js'

// Import Vue and Flash Notifications
import { createApp } from 'vue'
import FlashNotifications from './components/FlashNotifications.vue'

// Store Vue app instance
let flashApp = null

// Initialize Flash Notifications component
const initFlashNotifications = () => {
  const flashMount = document.getElementById('flash-notifications-mount')
  if (flashMount && !flashMount.hasAttribute('data-vue-mounted')) {
    if (flashApp) {
      flashApp.unmount()
    }
    flashApp = createApp(FlashNotifications)
    flashApp.mount(flashMount)
    flashMount.setAttribute('data-vue-mounted', 'true')
  }
}

// Initialize on DOMContentLoaded (first page load)
document.addEventListener('DOMContentLoaded', initFlashNotifications)

// Re-initialize on Turbo navigation (subsequent navigations)
document.addEventListener('turbo:load', initFlashNotifications)

// Clean up before cache
document.addEventListener('turbo:before-cache', () => {
  const flashMount = document.getElementById('flash-notifications-mount')
  if (flashMount && flashApp) {
    flashApp.unmount()
    flashMount.removeAttribute('data-vue-mounted')
    flashApp = null
  }
})
